// extracted by mini-css-extract-plugin
module.exports = {"addToBagBtn":"add-to-bag-button_component_addToBagBtn__0NHJr","addToCartProcessing":"add-to-bag-button_component_addToCartProcessing__ZdIyp"};